import { Provider } from "react-redux";
import { RouteConfig } from "./RouteConfig";
import { store } from "./store";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    // Global error handler to suppress 401 errors from being logged to console
    const originalConsoleError = console.error;
    console.error = (...args) => {
      // Check if the error is a 401 error from axios
      const is401Error = args.some(arg =>
        arg && typeof arg === 'object' &&
        (arg.status === 401 ||
          (arg.response && arg.response.status === 401) ||
          (arg.message && arg.message.includes('401')))
      );

      // Don't log 401 errors to console
      if (!is401Error) {
        originalConsoleError.apply(console, args);
      }
    };

    // Global unhandled promise rejection handler to suppress 401 errors
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      const error = event.reason;
      const is401Error = error && typeof error === 'object' &&
        (error.status === 401 ||
          (error.response && error.response.status === 401) ||
          (error.message && error.message.includes('401')));

      if (is401Error) {
        // Prevent the default browser behavior for 401 errors
        event.preventDefault();
      }
    };

    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    // Cleanup function to restore original console.error and remove event listener
    return () => {
      console.error = originalConsoleError;
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return (
    <Provider store={store}>
      <RouteConfig />
    </Provider>
  );
}

export default App;

